<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <SectionTemplate
        v-if="!loading && items.length"
        class="videos-section"
        title="Vídeos"
      >
        <div class="mt-10">
          <v-row class="my-0">
            <hooper-container
              class="videos-carousel"
              style="height: auto"
              :wheelControl="false"
              infiniteScroll
              :settings="settingsCarousel"
            >
              <hooper-slide v-for="(item, keyItems) in items" :key="keyItems">
                <v-col>
                  <VideoCard v-bind="item" />
                </v-col>
              </hooper-slide>

              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper-container>
          </v-row>
        </div>

        <div class="mt-10 text-center">
          <ButtonWidget :to="path">Veja todos os Vídeos</ButtonWidget>
        </div>
      </SectionTemplate>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import SectionTemplate from "../templates/SectionTemplate.vue";
import VideoCard from "../cards/VideoCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "videos",
  path: "/videos",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    itemsPerPage: 9,
    items: [],
    settingsCarousel: {
      itemsToShow: 1,
      breakpoints: {
        600: {
          itemsToShow: 2,
        },
        960: {
          itemsToShow: 3,
        },
      },
    },
  }),
  created() {
    this.get();
  },
  methods: {
    get() {
      this.$rest(_config.mod)
        .get({
          params: {
            itemsPerPage: this.itemsPerPage,
          },
        })
        .then((data) => {
          this.items = data;
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    LoadingWidget,
    SectionTemplate,
    VideoCard,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.videos-section::v-deep {
  .title-widget {
    &:before,
    &:after {
      background-color: var(--v-warning-darken2);
    }
  }
}

.videos-carousel::v-deep {
  ol,
  ul {
    padding-left: 0;
  }

  .hooper-pagination {
    bottom: -25px;

    .hooper-indicator {
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      height: 10px;
      margin-left: 3px;
      margin-right: 3px;
      width: 10px;

      &.is-active {
        background-color: var(--v-accent-base);
        height: 12px;
        width: 12px;
      }
    }
  }
}
</style>
